<template>
  <div class="memberIndex">
    <div class="right">
      <div class="currentMenu">招标/比选管理>投标结果</div>
      <div class="right_content">
        <div class="change_inform">
          <div class="title">投标结果</div>
        </div>
        <div class="right_out">
          <div style="padding: 5px; margin: 10px">
            <span>项目名称</span>
            <el-input type="text" class="searchinput" v-model="Query.ProjectName" size="mini"></el-input>
            <span>招标方式</span>
            <el-select class="searchinput" v-model="Query.PurchaseMethod" placeholder="请选择">
              <el-option v-for="item in PurchaseMethods" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
            </el-select>
            <span>项目类型</span>
            <el-select class="searchinput" v-model="Query.ProjectType" placeholder="请选择">
              <el-option v-for="item in ProjectTypes" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
            </el-select>
            <el-button id="search" @click="fnSearch">搜索</el-button>
          </div>
          <el-table class="table_wrap1" :data="tableData.slice((currentPage - 1) * PageSize, currentPage * PageSize)" style="width: 100%" :height="height">
            <el-table-column type="expand" style="padding: 0">
              <template slot-scope="props">
                <table class="statistics_table">
                  <tr>
                    <th class="th1">包组信息</th>
                    <th class="th1" style="width: 120px">投标结果</th>
                    <th class="th1" style="width: 240px">发布时间</th>
                    <th class="th1" style="width: 160px">操作</th>
                  </tr>
                  <tr v-for="(item, index) in props.row.schemeList" :key="index">
                    <td class="td1">{{ item.ProjectName }}-{{ item.GroupName }}</td>
                    <td class="td1">
                      <div v-if="item.Status != '已中标'" class="tag-normal">
                        <span>{{ item.Status }}</span>
                      </div>
                      <div v-if="item.Status == '已中标'" class="tag-success">
                        <span>{{ item.Status }}</span>
                      </div>
                    </td>
                    <td class="td1">{{ item.TenderConfirmDate }}</td>
                    <td class="td1">
                      <div class="btn_wrap">
                        <el-button @click="fnDetail(item.SchemeId)" class="btn" type="text" size="small">查看结果</el-button>
                      </div>
                    </td>
                  </tr>
                </table>
              </template>
            </el-table-column>

            <el-table-column prop="SchemeCode" label="采购编号"></el-table-column>
            <el-table-column prop="ProjectName" label="项目名称"></el-table-column>
            <el-table-column prop="PurchaseMethod" label="采购方式"></el-table-column>
            <el-table-column prop="ProjectType" label="项目类型"></el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      PurchaseMethods: [],
      ProjectTypes: [],
      Query: {},
      tableData: [],
      ownPurchaseMethod: [2, 3],
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 1,
      // 个数选择器（可修改）
      pageSizes: [10, 25, 50, 100],
      // 默认每页显示的条数（可修改）
      PageSize: 25,
      height: window.innerHeight - 268
    }
  },
  created() {},
  computed: {},
  mounted() {
    this.fnSearch()
    this.fnInit()
  },
  methods: {
    fnSearch() {
      //按照信息
      let config = {
        params: {
          Query: JSON.stringify(this.Query),
          PurchaseMethod: JSON.stringify(this.ownPurchaseMethod)
        }
      }
      this.getRequest('Purchase/GetBidResultList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.tableData = res.data.BidResultList
            this.totalCount = this.tableData.length
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnDetail(id) {
      let routerData = this.$router.resolve({
        name: 'BidResulDetail',
        query: {
          id: id
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnInit() {
      // //获取登录供应商基础信息
      // this.getRequest("SupplierLogin/MemberCenterData")
      //   .then(res => {
      //     if (res.data.errcode == 0) {
      //       this.loginInfos = res.data.logindata;
      //     } else {
      //       this.$message.error(res.data.errmsg);
      //     }
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //   });
      let config = {
        params: {
          PurchaseMethod: JSON.stringify(this.ownPurchaseMethod)
        }
      }
      this.getRequest('Purchase/GetInvitationQueryList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.PurchaseMethods = res.data.PurchaseMethods
            this.ProjectTypes = res.data.ProjectTypes
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })

      // this.getRequest("Purchase/GetBidResultList")
      //   .then(res => {
      //     if (res.data.errcode == 0) {
      //       this.tableData = res.data.BidResultList;
      //     } else {
      //       this.$message.error(res.data.errmsg);
      //     }
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //   });
    },
    // 分页
    // 每页显示的条数
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      this.currentPage = val
    }
  }
}
</script>
<style scoped lang="scss">
.memberIndex {
  display: flex;

  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;

    .logined_wrap {
      padding: 10px;

      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }

      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }

      .img {
        margin-left: 30px;
      }

      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;

          .labell {
            font-weight: bold;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .right {
    width: 100%;
    background: #e4e4e4;
    // flex: 1;
    padding: 0 0 10px 0;

    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .currentMenu {
      margin: 16px 5px;
    }

    .right_content {
      margin: 0 10px;
      // height: 93%;
      background: #f7f7f7;
      padding-bottom: 10px;
    }

    #search {
      width: 120px;
    }

    .input {
      width: 180px;
      margin-right: 50px;
      margin-left: 5px;
    }

    ::v-deep.el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
    }

    .btn_wrap {
      .btn {
        margin: auto;
        color: #6a96bc;
        border: 1px solid #6a96bc;
        border-radius: 5px;
        padding: 2px 18px;
      }
    }
  }
}
#search {
  width: 120px;
}

.searchinput {
  width: 180px;
  margin: 0 60px 0 10px;
}

.right_out {
  width: 98%;
  margin: 0 auto;
}

.welcome {
  height: 40px;
  line-height: 40px;
}

.currentMenu {
  margin: 16px 5px;
}

.right_content {
  margin: 0 10px;
  height: 93%;
  background: #f7f7f7;
}

.btn_wrap {
  display: inherit;

  .btn {
    color: #6a96bc;
    border: 1px solid #6a96bc;
    border-radius: 5px;
    padding: 2px 18px;
  }
}

.statistics_table {
  width: 100%;
  // margin: 5px auto;

  th,
  td {
    text-align: center;
  }

  th {
    background-color: rgba(243, 251, 255, 1);
    color: #0179bd;
    font-weight: 700;
  }
  .tag-success {
    background-color: rgba(240, 249, 236, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(225, 243, 216, 1);
    border-radius: 5px;
    display: inline-block;
    line-height: 30px;
    span {
      padding: 0 12px;
      font-family: 'Arial Normal', 'Arial';
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      color: #67c23a;
      text-align: center;
    }
  }

  .tag-danger {
    background-color: rgba(254, 241, 241, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(253, 226, 226, 1);
    border-radius: 5px;
    display: inline-block;
    line-height: 30px;
    span {
      padding: 0 12px;
      font-family: 'PingFang SC Regular', 'PingFang SC';
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      color: #f56c6c;
      text-align: center;
    }
  }

  .tag-normal {
    background-color: rgb(236, 236, 236);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(211, 211, 211);
    border-radius: 5px;
    display: inline-block;
    line-height: 30px;
    span {
      padding: 0 12px;
      font-family: 'PingFang SC Regular', 'PingFang SC';
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      color: rgb(180, 180, 180);
      text-align: center;
    }
  }
}
</style>